import { CopyToClipboard } from "@amzn/awsui-components-react/polaris";
import { Row, Col } from "antd"
import CBBTutorBubble from './CBBTutorBubble';
import UserBubble from "./UserBubble";

interface CBBTutorMessagesProps {
  index: number;
  message: { role: string; content: string };
  userInitial?: string;
}

const CBBTutorMessages = ({ index, message, userInitial }: CBBTutorMessagesProps) => {
  return (
      <Row key={index}>
        <Col span={24}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
            <div style={{ flex: 1 }}>
              {message.role === "user" ? (
                <UserBubble message={message} userInitial={userInitial}/>
              ) : (
                <CBBTutorBubble message={message}/>
              )}
            </div>
            <div className="message-copy-button">
              <CopyToClipboard
                copyButtonAriaLabel={message.role === "user" ? "Copy user question" : "Copy response"}
                copyErrorText="Failed to copy"
                copySuccessText="Copied!"
                textToCopy={message.content}
                variant="icon"
              />
            </div>
          </div>
        </Col>
      </Row>
  )
}

export default CBBTutorMessages;